export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6758.ee772358.jpg";